"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MatchSubscriptionTopics;
(function (MatchSubscriptionTopics) {
    MatchSubscriptionTopics["updates"] = "match/updated";
    MatchSubscriptionTopics["creates"] = "match/created";
    MatchSubscriptionTopics["summaryUpdates"] = "match/summaryUpdated";
    MatchSubscriptionTopics["lineupUpdates"] = "match/lineupUpdated";
    MatchSubscriptionTopics["deletes"] = "match/deleted";
})(MatchSubscriptionTopics = exports.MatchSubscriptionTopics || (exports.MatchSubscriptionTopics = {}));
//# sourceMappingURL=subscriptions.js.map